import type { SymbolRenderProps } from '../types';

const TIP_LENGTH = 2.5;
const TIP_HALF_HEIGHT = 1.5;
const SHAFT_WIDTH = 0.4;

export function ArrowResonance({ shaftLength }: SymbolRenderProps) {
  const halfShaft = shaftLength / 2;

  return (
    <g>
      <line
        x1={-halfShaft + TIP_LENGTH} y1={0}
        x2={halfShaft - TIP_LENGTH} y2={0}
        stroke="black" strokeWidth={SHAFT_WIDTH}
      />
      {/* Left arrowhead */}
      <polygon
        points={`${-halfShaft},0 ${-halfShaft + TIP_LENGTH},${-TIP_HALF_HEIGHT} ${-halfShaft + TIP_LENGTH},${TIP_HALF_HEIGHT}`}
        fill="black"
      />
      {/* Right arrowhead */}
      <polygon
        points={`${halfShaft},0 ${halfShaft - TIP_LENGTH},${-TIP_HALF_HEIGHT} ${halfShaft - TIP_LENGTH},${TIP_HALF_HEIGHT}`}
        fill="black"
      />
    </g>
  );
}
